import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/SimpleList/simple-list';
import { SimpleListContext } from './SimpleList';
export var SimpleListItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SimpleListItem, _React$Component);

  function SimpleListItem() {
    var _this;

    _classCallCheck(this, SimpleListItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimpleListItem).apply(this, arguments));
    _this.ref = React.createRef();
    return _this;
  }

  _createClass(SimpleListItem, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          children = _a.children,
          isCurrent = _a.isCurrent,
          className = _a.className,
          Component = _a.component,
          componentClassName = _a.componentClassName,
          componentProps = _a.componentProps,
          _onClick = _a.onClick,
          type = _a.type,
          href = _a.href,
          props = __rest(_a, ["children", "isCurrent", "className", "component", "componentClassName", "componentProps", "onClick", "type", "href"]);

      return React.createElement(SimpleListContext.Consumer, null, function (_ref) {
        var currentRef = _ref.currentRef,
            updateCurrentRef = _ref.updateCurrentRef;
        var isButton = Component === 'button';
        var isCurrentItem = _this2.ref && currentRef ? currentRef.current === _this2.ref.current : isCurrent;
        var additionalComponentProps = isButton ? {
          type: type
        } : {
          tabIndex: 0,
          href: href
        };
        return React.createElement("li", Object.assign({
          className: css(className)
        }, props), React.createElement(Component, Object.assign({
          className: css(styles.simpleListItemLink, isCurrentItem && styles.modifiers.current, componentClassName),
          onClick: function onClick(evt) {
            _onClick(evt);

            updateCurrentRef(_this2.ref, _this2.props);
          },
          ref: _this2.ref
        }, componentProps, additionalComponentProps), children));
      });
    }
  }]);

  return SimpleListItem;
}(React.Component);
SimpleListItem.defaultProps = {
  children: null,
  className: '',
  isCurrent: false,
  component: 'button',
  componentClassName: '',
  type: 'button',
  href: '',
  onClick: function onClick() {}
};